import './landingButtons.scss'
import React from "react"
import { Button } from "reactstrap"

const LandingButtons = ({buttons}: any) => {  
  return(
    <>
      {buttons.map(({click, title, target}: any) => (
        <div className='button-wrapper' key={title}>
          <a href={click} target={target} className='button-link'>
            <Button className="landing-button" variant='Link' size='lg'>{title}</Button>
          </a>
        </div>
      ))}
    </>
  )
}

export default LandingButtons